import { BASVURU_HARC_LISTESI } from "../constants/requestUrls";
import { getRequest } from "../request";

const basvuruHarcList = (basvuruId) => {
    // const data = {basvuruId};
    return getRequest({url:BASVURU_HARC_LISTESI+"?basvuruId="+basvuruId});
}

export default basvuruHarcList;